import { render } from "./RulesContainer.vue?vue&type=template&id=a823be6e&scoped=true"
import script from "./RulesContainer.vue?vue&type=script&lang=js"
export * from "./RulesContainer.vue?vue&type=script&lang=js"

import "./RulesContainer.vue?vue&type=style&index=0&id=a823be6e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a823be6e"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QSeparator,QList,QExpansionItem});
